import { render, staticRenderFns } from "./videoBlock3.vue?vue&type=template&id=53781586&"
import script from "./videoBlock3.vue?vue&type=script&lang=js&"
export * from "./videoBlock3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports